<template>
    <div role="radiogroup" aria-label="Checkout service type">
		<div v-if="!isStreamLined" :class="styleGroupContainer()">
			<div v-for="(action, index) in getServiceActions()" :key="`${action.type}-${index}`">
				<div @click="handleClick(action.type)"
					@keydown.enter="handleClick(action.type)"
					:aria-checked="isServiceOn(typeFromName(action.type))"
					:aria-label="action.label"
					role="radio"
					tabindex="0"
					:class="styleLongFormButton(typeFromName(action.type))">
					<BaseIcon
						:class="`${action.type}`"
						:icon="action.icon"
						:editStroke="false"
						:isCustom="true"
						:className="['order-icon']"
						size="2x">
						{{ action.label }}
					</BaseIcon>
				</div>
			</div>
		</div>
		<div v-else>
			<div v-for="(action, index) in getServiceActions()" :key="`${action.type}-${index}`">
				<BaseRadio
					v-if="isStreamLined"
					:name="getServiceDescription(action.label)"
					:click="() => handleClick(action.type)"
					:activeClass="showServiceActive(typeFromName(action.type))"
					:aria-checked="isServiceOn(typeFromName(action.type))"
					:ariaLabel="action.label"/>
			</div>
		</div>
		<p v-if="serviceType === EServiceType.SERVICE_TYPE_TAKEOUT" class="service-info-text">
			For pre-paid pickup, the cardholder must come to pickup their order. Please make sure the name on your ID matches the name on the card.
		</p>
        <div v-if="displayAddressChooser()">
            <hr>
            <div class="field">
                <label class="label">Choose address</label>
                <AddressChooser @success="err = ''" @error="(value) => err = value"/>
            </div>
        </div>
        <p class="store-navigation-color">{{err}}</p>
    </div>
</template>

<script>
import { ACCOUNT_CHECKOUT, ACCOUNT, LOCATION } from '@/stores/defs';
import { EPreorder } from '@/services/order.service';
import { EServiceType } from '@/models/interfaces/Orders/EServiceType';
import { ICON_NAMES } from "@/components/common/BaseIcon.vue";
import { mapActions, mapGetters } from 'vuex';
import { SERVICE_TYPE_ANALYTIC_EVENT } from "@/common/analytic-events/serviceTypeAnalyticEvent";
import { get as getResolve, filter } from 'lodash';
import AddressChooser from "@/components/checkout/AddressChooser";
import Analytics from '@Analytics';
import paymentMixin from '@Mixin/paymentMixin';
import serviceMixin from '@Mixin/serviceMixin';

export default {
	mixins: [
		paymentMixin,
		serviceMixin,
	],
    props: {
        showAddressChooser: {
            type: Boolean,
            default: false
        },
        highlightIcon: {
            type: Boolean,
            default: true
        },
        isStreamLined: {
            type: Boolean,
            default: false
        }
    },
    components: {
        AddressChooser
    }, 
    computed: {
        ...mapGetters({
            customer: ACCOUNT.GET_CUSTOMER,
            serviceType: ACCOUNT_CHECKOUT.GET_SERVICE_TYPE,
            userSetServiceType: ACCOUNT_CHECKOUT.GET_USER_SET_SERVICE_TYPE,
            location: LOCATION.GET_LOCATION
		}),
    },
    data() {
        return {
            err: "",
            EServiceType: EServiceType,
            ICON_NAMES: ICON_NAMES
        }
    },
    methods: {
        getServiceDescription(description) {
            return (this.$mq === 'mobile') ? `${description} from ${this.location.name}` : description;
		},
        ...mapActions({
            setServiceType: ACCOUNT_CHECKOUT.SET_SERVICE_TYPE,
            setUserSetServiceType: ACCOUNT_CHECKOUT.SET_USER_SET_SERVICE_TYPE
		}),
		getServiceActions() {
			let serviceActions = getResolve(
				this.$appConstants,
				'layoutOptions.service.actions',
				[],
			);
			if (!this.service_isDeliveryEnabled) {
				serviceActions = filter(serviceActions, (action) => {
					return action.type !== 'delivery';
				});
			}
			return serviceActions;
		},
		styleLongFormButton(serviceType) {
			const isServiceType = (this.getServiceType === serviceType);
			const showServiceActive = isServiceType && this.highlightIcon;
			return {
				'column' : true,
				'is-narrow' : true,
				'has-text-centered' : true,
				'service-type-icon' : true,
				'active' : showServiceActive,
			};
		},
		styleGroupContainer() {
			return {
				'service-icons' : true,
				'columns' : true,
				'is-mobile' : true, // used for tablets/desktop
				'is-centered' : this.$isMobile,
			};
		},
		displayAddressChooser() {
			const isDelivery = this.isForDelivery;
			return isDelivery && this.showAddressChooser;
		},
		handleClick(type) {
			const setServiceFunction = this._mapServiceFunctions(type);
			setServiceFunction();
			this.$tpa.trackCheckoutServiceType(type);
			this.$emit('newServiceType', type);
			this.$emit('service-type-changed',type);
		},
		isServiceOn(type) {
			return (this.getServiceType === type);
		},
		showServiceActive(type) {
			if (this.isServiceOn(type)) {
				return 'selected';
			}
			return '';
		}
	},
	mounted() {
		// if (this.serviceType === EServiceType.SERVICE_TYPE_TAKEOUT) {
		// 	this.$refs['radioTakeout'].$el.click();
		// }
		// if (this.serviceType === EServiceType.SERVICE_TYPE_DELIVERY) {
		// 	this.$refs['radioDelivery'].$el.click();
		// }
	}
}
</script>


<style lang="scss">
    @import "globalStyles";
    .service-type-icon {
        color: $navigationItemColor;
        border: 1px solid $greyOutline;
        padding: 0em;
        border-radius: 12px;
        margin-right: 8px;
        cursor: pointer;
        min-width: 150px;
        padding-top: 5px;
        padding-bottom: 5px;
        max-height: 68px;
    }

    .service-type-icon p {
        font-size: 1rem;
        font-weight: bold;
        margin: -2px;
    }

    .service-type-icon.active, .service-type-icon:hover {
        background-color: $storeButtonColor;
        color: white;
    }
</style>



// WEBPACK FOOTER //
// src/components/checkout/ServiceTypeChooser.vue